module.exports = __webpack_public_path__ + "static/media/slide (3).b68f7625.jpg";